import api from '@/shared/api/base-api';

const deleteUserApi = {
  delete: async (id: string) => {
    const res = await api.delete(`/v2/customers/self-delete/${id}`);
    return res.data;
  },
};

export default deleteUserApi;
